import { useEffect, useState } from "react"

import { visibleDocumentVersions, extractDeleteReason } from "../../../../lib/docs"
import { formatDateLocal } from "../../../../lib/script"
import DocumentCell from "./DocumentCell"
import { documentsTypes, practicesOptions } from "../../../../lib/systemData"
import UpdateDocument from "./UpdateDocument"

import classes from './DocumentsTabListItem.module.css'
import DisplayBoxRight from "../../../fragments/DisplayBoxRight"
import EditDocument from "./EditDocument"
import DocumentEditable from "./DocumentEditable"
import DeleteDocument from "./DeleteDocument"
import RestoreDocument from "./RestoreDocument"
import HardDeleteCaseDocument from "./HardDeleteCaseDocument"

const DocumentsTabListItem = ({data, secondary, isOlder, parent, isDeleted = false, deletePermission, restorePermission, hardDeletePermission}) => {
    const [showRelatedFiles, setShowRelatedFiles] = useState(false)
    const [isEditing, setIsEditing] = useState(false)

    const [practicesMultipleDefaultSelectionString, setPracticesMultipleDefaultSelectionString] = useState(null)

    const showRelatedFilesHandler = () => {
        setShowRelatedFiles(prevState => prevState = !prevState)
    }

    let types = documentsTypes()
    let practices = practicesOptions()

    useEffect(() => {
        let practicesString = ''
        if (practices && data.practices) {    
            data.practices.forEach(element => {
                if (element != 'all') {
                    let vals = practices.find(item => item.value == element)            

                    practicesString = practicesString ? (practicesString + ', ' + vals?.label) : vals?.label
                } else {
                    practicesString = element
                }
            });
            setPracticesMultipleDefaultSelectionString(practicesString)
        }

    }, [data])

    function returnType() {
        let type = types.find(item => item.value == Number(data.document_type_id))?.data.type
        return type
    }

    function returnDocumentType() {
        let type = types.find(item => item.value == Number(data.document_type_id))?.label
        return type
    }

    function setIsEditingHandler(value) {
        setIsEditing(value)
    }

    function cancelEditFileHandler() {
        setIsEditing(false)
    }

    const visibleVersions = visibleDocumentVersions(data)
    const displayName =
        data.file_name != null && String(data.file_name).trim() !== ''
            ? data.file_name
            : returnDocumentType()
    const deleteReason = isDeleted ? extractDeleteReason(data) : null

    return <>
        <tr className={`${(showRelatedFiles || secondary) ? classes.item_opened : ''} ${secondary ? classes.secondary : ''} ${isEditing ? classes.editing_row : ''} ${isDeleted ? classes.deleted_row : ''}`}>
            {/* name and controls  */}
            <td>  
                <div className={classes.name_container_outer}>
                    {visibleVersions.length > 0 && <div className={classes.has_previous_files}>
                        <button onClick={showRelatedFilesHandler} className={showRelatedFiles ? classes.button_active : ''}><i className="ti ti-chevron-right"></i></button>                         
                    </div>}
                    <div className={classes.name_container}>
                        <div>
                            {displayName}
                            {visibleVersions.length > 0 && <div className={classes.prev_details}>{visibleVersions.length} more previous version{visibleVersions.length == 1 ? '' : 's'}</div>}
                        </div>
                        <DocumentCell file={data} isPrevious={secondary} parent={parent} isNormalDoc={true} isDeleted={isDeleted}/>
                    </div>
                </div>    
            </td>
            {/* created at  */}
            <td>{data.created_at && <DisplayBoxRight>{formatDateLocal(data.created_at)}</DisplayBoxRight>}</td>

            {/* user name  */}
            <td>{data.user && data.user.name}</td>

            {!isOlder && !isDeleted && <>

                {!isEditing && <>
                    {/* document type  */}
                    <td>
                        <>{data.document_type_id && returnDocumentType()}</>
                    </td>  

                    {/* practice --- this is available only if the type is practice  */}
                    <td>
                        {returnType() == 'Practice' && practicesMultipleDefaultSelectionString && practicesMultipleDefaultSelectionString}
                        {returnType() !== 'Practice' && <>-</>} 
                    </td>

                    {/* notes  */}
                    <td>
                        {data.notes}
                    </td>

                    {/* update controls  */}
                    <td>
                        {!secondary && <div className={classes.controls}>
                            <EditDocument document={data} setIsEditingHandler={setIsEditingHandler} isEditing={isEditing}/>
                            <UpdateDocument document={data}/>
                            {deletePermission && <DeleteDocument document={data} hardDeletePermission={hardDeletePermission}/>}
                        </div>}
                    </td>
                </>}
                {isEditing && <DocumentEditable data={data} isEditing={data} cancelEditFile={cancelEditFileHandler}/>}
            </>}



            {isOlder && !isDeleted && <td colSpan={5}></td>}

            {isDeleted && <>
                <td>
                    <>{data.document_type_id && returnDocumentType()}</>
                </td>
                <td>
                    {returnType() == 'Practice' && practicesMultipleDefaultSelectionString && practicesMultipleDefaultSelectionString}
                    {returnType() !== 'Practice' && <>-</>}
                </td>
                <td>
                    <div>
                        {data.deleted_at && <>Deleted {formatDateLocal(data.deleted_at)}</>}
                        {data.deleted_by_user?.name && <> by {data.deleted_by_user.name}</>}
                    </div>
                    {deleteReason && (
                        <div className={classes.deleted_reason}>Reason: {deleteReason}</div>
                    )}
                </td>
                <td>
                    <div className={classes.controls}>
                        {restorePermission && data.can_restore && <RestoreDocument document={data} />}
                        {hardDeletePermission && data.can_hard_delete_file && <HardDeleteCaseDocument document={data} />}
                    </div>
                </td>
            </>}
        </tr>


        {showRelatedFiles && visibleVersions.length > 0 && visibleVersions.map(item => (
            <DocumentsTabListItem key={item.id} data={item} secondary={true} isOlder={true} parent={data}/>
        ))}
    </>
}

export default DocumentsTabListItem